import { useLayoutEffect } from "react";
import { useAuth } from "@/core/auth";
import { useGetMyUser } from "@/user/query";
import { isTech } from "@/user/utils";
import { setPylonAccessAllowed } from "./pylon-access";
import { isPylonHideRequested } from "./pylon-sidebar-visibility";

export const usePylonAccess = () => {
  const { user: authUser } = useAuth();
  const { data: user } = useGetMyUser();
  const hasAccess =
    !!user && !!authUser && !isTech(authUser.role) && !isTech(user.role);

  useLayoutEffect(() => {
    setPylonAccessAllowed(hasAccess);
    if (hasAccess && !isPylonHideRequested()) {
      window.Pylon?.("showChatBubble");
    }
    return () => setPylonAccessAllowed(false);
  }, [hasAccess]);

  return hasAccess;
};
